export class SubNav{

    constructor(){
        this.$nav = $('.c-sub-nav');
        this.$content = this.$nav.find('.c-sub-nav__content');
        this.$sections = this.$nav.find('.c-sub-nav__section');
        const $triggerOpen = this.$nav.find('.js-open-sub-nav');
        const $triggerClose = this.$nav.find('.js-close-sub-nav');

        $triggerOpen.on('click', e => this.open(e));
        $triggerClose.on('click', () => this.close());
    }

    open(e){
        const target = $(e.currentTarget).data('section');
        this.$nav.addClass('c-sub-nav--active');
        $('body').addClass('body--no-scroll');
        $('.js-' + target + '-section').show();
        setTimeout(()=>{
            this.$content.addClass('c-sub-nav__content--active');
        }, 300);
    }

    close(){
        this.$nav.removeClass('c-sub-nav--active');
        $('body').removeClass('body--no-scroll');
        this.$content.removeClass('c-sub-nav__content--active');
        this.$sections.hide();
    }

}